import { Selector } from '@ngxs/store';
import { OrderMetadataState } from './order-metadata.state';
import { OrderMetadataStateModel } from './order-metadata.type';

export class OrderMetadataStateSelectors {
  @Selector([OrderMetadataState])
  static getState(state: OrderMetadataStateModel): OrderMetadataStateModel {
    return state;
  }
}
